<div class="password-requirements" *ngIf="password.length > 0">
  <p class="requirement-title">{{ 'password-validation.title' | translate }}</p>
  <ul>
    <li *ngFor="let rule of validationRules"
        [class.valid]="isRuleValid(rule)"
        [class.invalid]="!isRuleValid(rule)">
      <span class="icon">{{ isRuleValid(rule) ? 'OK' : 'X' }}</span> {{ rule.labelKey | translate }}
    </li>
  </ul>
</div>
